import React from "react";
import { FormControl } from "react-bootstrap";
import { DisplayBox, Loading } from "../../components";
import { ApiHelper, ArrayHelper, DepartmentInterface, UserHelper } from "../../helpers";
import { Redirect } from "react-router-dom";

interface Props {

}

export const AdminUserSearch: React.FC<Props> = props => {
  const [allRows, setAllRows] = React.useState<any[]>(null);
  const [searchText, setSearchText] = React.useState("");
  const [redirect, setRedirect] = React.useState("");

  const impersonate = async (departmentId: number) => {
    const department = await ApiHelper.get("/departments/impersonate/" + departmentId);

    UserHelper.departments.push(department);
    UserHelper.currentDepartment = department;
    UserHelper.departmentChanged = true;
    ApiHelper.setDefaultPermissions(UserHelper.currentDepartment.jwt);
    setRedirect("/messages");
  }

  const getRows = () => {
    const rows: any[] = filterRows();
    const result: JSX.Element[] = [];
    rows.forEach(r => {
      const row = r;
      result.push(<tr>
        <td>{r.name}</td>
        <td>{r.email}</td>
        <td>{r.departmentName}</td>
        <td>
          <a href="about:blank" onClick={(e) => { e.preventDefault(); impersonate(row.departmentId) }} ><i className="fas fa-user-secret" /></a>
        </td>
      </tr>);
    });
    return result;
  }

  const filterRows = () => {
    if (searchText === "") return ArrayHelper.limit(allRows, 15);
    else {
      const v = searchText.toLowerCase();
      const result: any[] = []
      for (const row of allRows) {
        if (row.email.toLowerCase().indexOf(v) > -1 || row.name.toLowerCase().indexOf(v) > -1) result.push(row);
      }
      ArrayHelper.sort(result, "name", false);
      ArrayHelper.sort(result, "accountName", false);
      return ArrayHelper.limit(result, 25);
    }
  }

  const getTable = () => {
    if (allRows === null) return <Loading />
    else {
      return (<table className="table table-sm table-striped" style={{ marginTop: 10 }}>
        <thead>
          <tr>
            <th>Account</th>
            <th>Department</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {getRows()}
        </tbody>
      </table>);
    }
  }

  const init = () => {
    ApiHelper.get("/users/adminList").then((data: DepartmentInterface[]) => setAllRows(data));
  }

  React.useEffect(init, [])

  const getEditContent = () => {
    return (<FormControl size="sm" placeholder="Search" value={searchText} onChange={(e) => setSearchText(e.currentTarget.value)} />)
  }

  if (redirect !== "") return <Redirect to={redirect} />
  else return (
    <DisplayBox headerText="Users" headerIcon="fas fa-users" editContent={getEditContent()}>
      {getTable()}
    </DisplayBox>
  );
};